import apiClient from "./apiClient";

const classroomServices = {
  getClassrooms: () => {
    return apiClient.get(`/classrooms?per_page=2000&order_dir=asc`);
  },
  getAllowedClassrooms: (student_id) => {
    return apiClient.get(`/allowed-classrooms/${student_id}`);
  },
  getStudentsByClassroomID: (classroomId, { search, per_page, order_dir } = {}) => {
    const params = new URLSearchParams();

    if (search) params.append("search", search);
    if (per_page) params.append("per_page", 1000);
    if (order_dir) params.append("order_dir", order_dir);

    return apiClient.get(`/classroom-students/${classroomId}?${params.toString()}`);
  },

  getClassroomLessons: (classroomId, { type } = {}) => {
    const params = new URLSearchParams();

    if (type) params.append("type", type);

    return apiClient.get(`/classroom-lessons/${classroomId}?${params.toString()}`);
  },

  getClassroomStudentsCompletions: (classroomId, lessonId) => {
    return apiClient.get(`/classroom-students-completions/${classroomId}/${lessonId}`);
  },
  getClassroomTopStudents: (classroomId, payload) => {
    return apiClient.get(`/classroom-top-students/${classroomId}`, payload);
  },

  finishLesson: (payload) => {
    return apiClient.post(`/student-finish-lesson`, payload);
  },

  getClassroomStudentsCodeCompletions: (classroomId, lessonId, { type } = {}) => {
    const params = new URLSearchParams();

    if (type) params.append("type", type);

    const url = lessonId
      ? `/classroom-students-code-completions/${classroomId}/${lessonId}?${params.toString()}`
      : `/classroom-students-code-completions/${classroomId}?${params.toString()}`;

    return apiClient.get(url);
  },

  getClassroomStudentProjectsCodeCompletions: (student_id, { type } = {}) => {
    const params = new URLSearchParams();

    if (type) params.append("type", type);

    const url = `/student-code-projects/${student_id}?${params.toString()}`;

    return apiClient.get(url);
  },

  addNewClassroom: (payload) => {
    return apiClient.post("/classrooms", payload);
  },

  resetChallengesOrQuestions: (type, payload) => {
    return apiClient.post(`/reset/${type}`, payload);
  },

  getClassroomDetails: (classroomId) => {
    return apiClient.get(`/classrooms/${classroomId}`);
  },
  getClassroomTimeline: (classroomId) => {
    return apiClient.get(`/classroom-history/${classroomId}`);
  },
  getClassroomStats: (classroomId) => {
    return apiClient.get(`/classroom-stats/${classroomId}`);
  },
  deleteClassroom: (classroomId) => {
    return apiClient.delete(`/classrooms/${classroomId}`);
  },
  logoutAllStudents: (classroomId) => {
    return apiClient.get(`/logout-students/${classroomId}`);
  },
  editClassroom: (classroomID, payload) => {
    return apiClient.post(`/classrooms/${classroomID}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  exportClassroomReport: (classroomID, payload) => {
    return apiClient.get(`/classroom-report/${classroomID}`, {
      params: payload,
      responseType: "blob",
    });
  },

  classroomProjectsStats: (classroomID) => {
    return apiClient.get(`/classroom-projects-stats/${classroomID}`);
  },

  reassignClassroom: (classroomID, payload) => {
    return apiClient.post(`/classrooms/${classroomID}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  reassignMultiClassrooms: (payload) => {
    return apiClient.post(`/reassign-classrooms`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  exportClassroomTemplate: () => {
    return apiClient.get(`/export-classroom-template`, {
      responseType: "blob",
    });
  },
  previewClassroomsSheet: (teacherId, payload) => {
    return apiClient.post(`/preview-classrooms-sheet/${teacherId}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  importClassroomTemplate: (teacherId, payload) => {
    return apiClient.post(`/import-classroom-template/${teacherId}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export default classroomServices;
